import { Client, CreateClient, UpdateClient, UpdateClientStatusDto } from '@/entities/clients';
import { Api } from './api/axios-config';
import { ClientContact, CreateClientContact, UpdateClientContact} from '@/entities/clientContact';

export class ClientService{
    
  private static api = Api();

  public static  async  getClients():Promise<Client[] | null> {
    const response = await this.api.get<any>('client');
    if(response.status === 200){
      return response.data.map((data:Client) => ({
        id: data.id,
        status: data.status,
        cpfCnpj: data.cpfCnpj,
        corporateName: data.corporateName,
        activityBranch: data.activityBranch,
        contacts: data.contacts.map((c)=>({
          id: c.id,
          name: c.name,
          email: c.email,
          clientId: data.id,
          phone: c.phone,
          cellPhone: c.cellPhone,
          function: c.function
        })) || [],
        fantasyName: data.fantasyName,
        address: data.address ? {
          id: data.address.id,
          zipCode: data.address.zipCode,
          complement: data.address.complement,
          address: data.address.address,
          city: data.address.city,
          number: data.address.number,
          federativeUnit: data.address.federativeUnit,
          ibgeCode: data.address.ibgeCode,
          neighborhood: data.address.neighborhood
        } : null,
        companyId: data.companyId
      }));
    }
    return null;
  } 

  public static  async  getClientsByCompanyId():Promise<Client[] | null> {
    const response = await this.api.get<any>('clientByCompany');
    if(response.status === 200){
      return response.data.map((data:Client) => ({
        id: data.id,
        status: data.status,
        cpfCnpj: data.cpfCnpj,
        responsible: data.responsible,
        corporateName: data.corporateName,
        activityBranch: data.activityBranch,
        contacts: data.contacts.map((c)=>({
          id: c.id,
          name: c.name,
          email: c.email,
          clientId: data.id,
          phone: c.phone,
          cellPhone: c.cellPhone,
          function: c.function
        })),
        fantasyName: data.fantasyName,
        address: {
          id: data.address.id,
          zipCode: data.address.zipCode,
          complement: data.address.complement,
          address: data.address.address,
          city: data.address.city,
          number: data.address.number,
          federativeUnit: data.address.federativeUnit,
          ibgeCode: data.address.ibgeCode,
          neighborhood: data.address.neighborhood
        },
        companyId: data.companyId
      }));
    }
    return null;
  }

  public static async createClient(client: CreateClient ){
    const response = await this.api.post<any>('newclient', {
      status: client.status,
      cpfCnpj: client.cpfCnpj,
      responsible: client.responsible,
      corporateName: client.corporateName,
      fantasyName: client.fantasyName,
      activityBranchId: client.activityBranchId,
      companyId: client.companyId,
      address: {
        zipCode: client.address?.zipCode,
        complement: '',
        number: client.address?.number,
        ibgeCode: '',
        address: client.address?.address,
        neighborhood: client.address?.neighborhood,
        federativeUnit:client.address?.federativeUnit,
        city:client.address?.city,
      },
    });
    if(response.status === 201){
      return response.data;
    }
    return null;
  }

  public static async create(client: CreateClient ){
    const response = await this.api.post<any>('client', {
      status: client.status,
      cpfCnpj: client.cpfCnpj,
      responsible: client.responsible,
      corporateName: client.corporateName,
      fantasyName: client.fantasyName,
      activityBranchId: client.activityBranchId,
      companyId: client.companyId,
      address: {
        zipCode: client.address?.zipCode,
        complement: '',
        number: client.address?.number,
        ibgeCode: '',
        address: client.address?.address,
        neighborhood: client.address?.neighborhood,
        federativeUnit:client.address?.federativeUnit,
        city:client.address?.city,
      },
    });
    if(response.status === 201){
      return response.data;
    }
    return null;
  }

  public static async deleteCascadeClient(id:number, adId:number){
    const response = await this.api.delete<any>(`client/${id}/${adId}`);
    if(response.status === 200){
      return response.data;
    }
    return null;
  }

  public static async updateClient(client: UpdateClient){
    const response = await this.api.post<any>('clientUpdate', {
      id: client.id,
      status: client.status,
      cpfCnpj: client.cpfCnpj,
      responsible: client.responsible,
      corporateName: client.corporateName,
      fantasyName: client.fantasyName,
      activityBranch: client.activityBranchId,
      address: {
        zipCode: client.address.zipCode,
        complement: '',
        number: client.address.number,
        ibgeCode: '',
        address: client.address.address,
        neighborhood: client.address.neighborhood,
        federativeUnit:client.address.federativeUnit,
        city:client.address.city,
      },
    });
    if(response.status === 201){
      return response.data;
    }
    return null;
  }  

  public static async getContact(clientId:number):Promise<ClientContact[] | []>{
    const response = await this.api.get<any>(`contact/${clientId}`);
    if(response.status === 200){
      return response.data.map((c:any)=>({
        id: c.id,
        name: c.name,
        email: c.email,
        clientId: c.clientId,
        phone: c.phone,
        cellPhone: c.cellPhone,
        function: c.function
      }));
    }
    return [];
  }

  public static async createClientContact(clientId:number, contact: CreateClientContact){
    const response = await this.api.post<any>(`contactCreate/${clientId}`, {
      name: contact.name,
      email: contact.email,
      clientId: contact.clientId,
      phone: contact.phone,
      cellPhone: contact.cellPhone,
      function: contact.function,
    });
    if(response.status === 201){
      return response.data;
    }
    return null;
  }

  public static async updateClientContact(contact:UpdateClientContact){
    const response = await this.api.post<any>('contactUpdate', {
      id: contact.id,      
      name: contact.name,
      email: contact.email,
      phone: contact.phone,
      cellPhone: contact.cellPhone,
      function: contact.function,
    });

    if(response.status === 201){
      return response.data;
    }
    return null;
  }

  public static async deleteClientContact(id:number){
    const response = await this.api.delete(`deleteContact/${id}`);
    if(response.status === 200){
      return response.data;
    }
    return null;
  }

  public static async deleteAllContact(clientId:number){
    const response = await this.api.delete(`deleteAllContact/${clientId}`);
    if(response.status === 200){
      return response.data;
    }
    return null;
  }
  
  public static async updateClientStatus(id:number, client:UpdateClientStatusDto){
    const response = await this.api.post(`updateClientStatus/${id}`,
      {status:client.status}
    );
    if(response.status === 201){
      return response.data;
    }
    return null;
  }

  public static async searchClient(contains:string){
    const response = await this.api.get(`searchClient/${contains}`);
    if(response.status === 200){
      return response.data.map((data:any) => ({
        id: data.id,
        status: data.status,
        cpfCnpj: data.cpfCnpj,
        corporateName: data.corporateName,
        activityBranch: data.activityBranch.name,
        contacts: data.contacts.map((c:any)=>({
          id: c.id,
          name: c.name,
          email: c.email,
          clientId: data.id,
          phone: c.phone,
          cellPhone: c.cellPhone,
          function: c.function
        })),
        fantasyName: data.fantasyName,
        address: {
          id: data.address.id,
          zipCode: data.address.zipCode,
          complement: data.address.complement,
          address: data.address.address,
          city: data.address.city,
          number: data.address.number,
          federativeUnit: data.address.federativeUnit,
          ibgeCode: data.address.ibgeCode,
          neighborhood: data.address.neighborhood
        },
        companyId: data.companyId
      }));
    }
    return null;
  }

}
